import { ErpWorkflowCoreModule } from './rm/erp/common/workflow/erpworkflow-core.module';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';

import { HisCoreModule } from 'hisng'; // start HISinOne specific

import { AppComponent } from './app.component';
import { ErpStartpageComponent } from './erp-startpage.component';
import { AppRoutesModule } from './app.routes';
import { JobApplicationCoreModule } from 'app/rm/erp/jobapplication/jobapplication-core.module';
import { JobAdvertisementCoreModule } from 'app/rm/erp/jobadvertisement/jobadvertisement-core.module';
import { PersonCoreModule } from './rm/erp/common/person/person-core.module';
import { DocumentCoreModule } from './rm/erp/common/document/document-core.module';
import { CommonCoreModule } from './rm/erp/common/common-core.module';
import { TimeManagementCoreModule } from './rm/erp/timemanagement/timemanagement-core.module';
// eslint-disable-next-line max-len
import { BusinesstripApplicationManagementCoreModule } from './rm/erp/travelmanagement/businesstripapplication/businesstripapplication-core.module';

@NgModule( {
    declarations: [
        AppComponent,
        ErpStartpageComponent
    ],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        CommonCoreModule,
        FormsModule,
        HttpClientModule,
        HisCoreModule,
        AppRoutesModule,
        JobApplicationCoreModule,
        JobAdvertisementCoreModule,
        PersonCoreModule,
        DocumentCoreModule,
        CommonCoreModule,
        TimeManagementCoreModule,
        BusinesstripApplicationManagementCoreModule,
        ErpWorkflowCoreModule
    ],
    bootstrap: [AppComponent]
} )
export class AppModule { }
